export default function StatCard({ label, value, sub, variant = '' }) {
  return (
    <div className={`stat-card ${variant}`.trim()}>
      <div className="k">{label}</div>
      <div className="v">{value}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
  );
}
